import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06296301"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center py-4" }, "Nu au avut loc consultații", -1))
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 1 }

import { ref, PropType, computed } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';

import { Consultation } from '@/interfaces/Consultation';
import { DateUtils } from '@/utils/DateUtils';
import type { Patient } from '@/interfaces/Patient';


export default /*#__PURE__*/_defineComponent({
  __name: 'PatientConsultationList',
  props: {
  consultations: {
    type: Array as PropType<Consultation[]>,
    default: () => []
  },
  patient: {
    type: Object as PropType<Patient | null>,
    default: null
  }
},
  setup(__props) {

const props = __props;

const sortedConsultations = computed(() => {
  return [...props.consultations].sort((a, b) => {
    return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
  });
});

const safe = (v: any) => (v != null ? v + ' RON' : '0 RON');
const safeDisplay = (value?: string | null): string => value ?? '';

const patientName = computed(() => {
  if (!props.patient) return '-';
  return [safeDisplay(props.patient.firstName), safeDisplay(props.patient.lastName)]
    .filter(Boolean).join(' ') || '-';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(DataTable), {
      value: sortedConsultations.value,
      stripedRows: "",
      paginator: "",
      rows: 10,
      rowsPerPageOptions: [10, 20, 50]
    }, {
      empty: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(Column), { header: "Pacient" }, {
          body: _withCtx(() => [
            _createTextVNode(_toDisplayString(patientName.value), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Data consultatie",
          field: "startDate",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_unref(DateUtils).format(data.startDate)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          header: "Valoare consultatie",
          field: "value",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_unref(Tag), {
              value: safe(data.value).toString(),
              severity: "info"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), { header: "Factura" }, {
          body: _withCtx(({ data }) => [
            (data.invoiceUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: data.invoiceUrl,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "text-blue-600 underline"
                }, " Descarcă PDF ", 8, _hoisted_2))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, "-"))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})